import { render, staticRenderFns } from "./CartIndex.vue?vue&type=template&id=cedc5fa0"
import script from "./CartIndex.vue?vue&type=script&lang=js"
export * from "./CartIndex.vue?vue&type=script&lang=js"
import style0 from "./CartIndex.vue?vue&type=style&index=0&id=cedc5fa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports